import { render, staticRenderFns } from "./FileDetail.vue?vue&type=template&id=2e2dd1e0&scoped=true&"
import script from "./FileDetail.vue?vue&type=script&lang=ts&"
export * from "./FileDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2dd1e0",
  null
  
)

export default component.exports